// Card payments (add-card + pay-by-card) run through Braintree, whose merchant
// account is not live yet. This single flag gates every card-tokenization entry
// point in the billing UI. Flip to true once Braintree is on-air to re-enable
// adding cards and paying invoices by card.
export const CARD_PAYMENTS_ENABLED = false;
